export var FGTMEventEnum;
(function (FGTMEventEnum) {
    FGTMEventEnum["config"] = "config";
    FGTMEventEnum["gtm_js"] = "gtm.js";
    FGTMEventEnum["page_view"] = "custom_page_view";
    FGTMEventEnum["add_to_cart"] = "add_to_cart";
    FGTMEventEnum["validation"] = "validation";
    FGTMEventEnum["purchase"] = "purchase";
    FGTMEventEnum["purchase_gift_voucher"] = "purchase_gift_voucher";
    FGTMEventEnum["confirm_booking_failed"] = "confirm_booking_failed";
})(FGTMEventEnum || (FGTMEventEnum = {}));
export var FGA4ConfirmBookingErrorTypeEnum;
(function (FGA4ConfirmBookingErrorTypeEnum) {
    FGA4ConfirmBookingErrorTypeEnum["make_reservation"] = "make_reservation";
    FGA4ConfirmBookingErrorTypeEnum["create_gift"] = "create_gift";
    FGA4ConfirmBookingErrorTypeEnum["form_errors"] = "form_errors";
    FGA4ConfirmBookingErrorTypeEnum["slot_is_full"] = "slot_is_full";
    FGA4ConfirmBookingErrorTypeEnum["payment"] = "payment";
    FGA4ConfirmBookingErrorTypeEnum["internal_server_error"] = "internal_server_error";
})(FGA4ConfirmBookingErrorTypeEnum || (FGA4ConfirmBookingErrorTypeEnum = {}));
